export default __webpack_public_path__ + "static/media/dabur.b1df6586.jpg";